import React, { useEffect, useState } from "react";
import {
  Button,
  Carousel,
  //  Placeholder
} from "react-bootstrap";
import "../../assets/css/style.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";
export default function HeroSection({ bannerData, loading }) {
  const [loggedin, setLoggedIn] = useState(false);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.USER_DATA);

  useEffect(() => {
    if (user) {
      setLoggedIn(true);
    }
  }, [user]);
  // console.log("Banner data: ", bannerData);
  return (
    <section className="hero-section mb-5 mt-4">
      <div className="text-center hero-intro">
        {/* <span className="hero-badge">Gujarati Samaj of Tampa Bay</span> */}
        <h1 className="hero-title">
          Welcome to Gujarati Samaj of Tampa Bay
          {/* <br /> */}
          {/* of Tampa Bay */}
        </h1>
        <p className="hero-legal f-16 mx-auto" style={{ color: "#418744" }}>
          Gujarati Samaj of Tampa Bay Inc is nonprofit organization recognized as tax-exempt under Section 501(c)(3) of the Internal Revenue Code
        </p>
        <p className="hero-sub">
          Gujarati Samaj of Tampa Bay Inc (GSTB) is a vibrant cultural organization
          dedicated to preserving and promoting Gujarati heritage, culture, and
          traditions in the Tampa Bay area.
        </p>

        {!loggedin && (
          <Button
            className="btn btn-orange btn-event-details w-auto px-4"
            onClick={() => navigate("/membership")}
          >
            Become a Member
          </Button>
        )}
      </div>

      <div className="hero-carousel-wrapper mt-4 position-relative">
        {/* decorative shapes behind slider */}
        <div className="hero-shape hero-shape-1" aria-hidden="true" />
        <div className="hero-shape hero-shape-2" aria-hidden="true" />

        {loading ? (
          <Skeleton height={450} borderRadius={12} />
        ) : (
          bannerData &&
          bannerData.length > 0 && (
            <div className="hero-slider-card mx-auto">
              <Carousel
                className="hero-slider"
                indicators={false}
                interval={4500}
                pause="hover"
                prevIcon={<span className="carousel-control-prev-icon" />}
                nextIcon={<span className="carousel-control-next-icon" />}
              >
                {bannerData.map((banner) => (
                  <Carousel.Item key={banner._id}>
                    <img
                      className="d-block w-100 hero-slide-img"
                      src={`${IMAGE_BASEURL}${banner.image_path}`}
                      alt={banner?.title}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          )
        )}
      </div>
    </section>
  );
}
